import { styled } from 'goober';

import { Flexbox } from '@/ui/flexbox/flexbox';
import { filterCssPropertiesFromMetadata } from '@/helpers/filter-css-properties-from-metadata';
import { useCurrentAccountData } from '@/hooks/use-current-account-data';

type AskXFooterActionsProps = {
  actionComponent?: React.ReactNode;
};

export const AskXFooterActions = ({
  actionComponent,
}: AskXFooterActionsProps) => {
  const { data } = useCurrentAccountData();
  if (!data) return null;

  return (
    <AskXFooter name="ask-x-footer" justify="space-between" alignItems="center">
      <Flexbox name="ask-x-logo" alignItems="center" gap="7px" fullWidth>
        <Logo
          src={data.logoDarkMode.url}
          alt={data.name}
          styleOverride={filterCssPropertiesFromMetadata(
            data.logoDarkMode.metadata,
          )}
        />
      </Flexbox>
      {actionComponent}
    </AskXFooter>
  );
};

const AskXFooter = styled(Flexbox)`
  width: 100%;
  background-repeat: repeat;
`;

interface BrandImageProps {
  styleOverride?: Record<string, string>;
}

const Logo = styled('img')<BrandImageProps>`
  max-height: 100%;
  max-width: 100%;

  width: 108px;
  height: 43px;

  ${({ styleOverride }) => styleOverride}
`;
